<section class="p-2 p-md-4">

    <div *ngIf="usuario.permissoes.administrador" class="mb-3 d-flex justify-content-end">
        <a [routerLink]="['/tabela-preco','laudo','tabela-padrao']"
            class="btn btn-lg btn-icon d-inline-flex"
            [ngClass]="{ 'btn-success': !tabelaPadrao, 'btn-theme': tabelaPadrao }">
          <i class="mdi" [ngClass]="{ 'mdi-plus': !tabelaPadrao, 'mdi-pencil': tabelaPadrao }"></i>
          <span>Tabela de preço padrão</span>
        </a>
      </div>

    <div class="card">
      <div class="table-responsive">

        <p-table #dt [columns]="cols"
        styleClass="p-datatable-responsive-demo table table-striped table-hover table-responsive-md"
        [value]="listaTabelaPreco" exportFilename={{dynamicdownloadName}} csvSeparator=";" selectionMode="single"
        [(selection)]="object" [first]="first">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [tableOrderGroup]="search.sorting" [(tableOrder)]="search.sorting.id"
              (tableOrderChange)="setOrder()">#</th>
            <th [tableOrderGroup]="search.sorting" [(tableOrder)]="search.sorting.nome"
              (tableOrderChange)="setOrder()">Nome</th>
            <th [tableOrderGroup]="search.sorting" [(tableOrder)]="search.sorting.descricao"
              (tableOrderChange)="setOrder()">Descrição</th>
            <th class="text-center py-2" *ngIf="usuario.permissoes.administrador" style="width: 10%;">
              <a [routerLink]="['/tabela-preco','laudo', 'adicionar']" class="btn btn-sm btn-success btn-icon">
                <i class="mdi mdi-plus"></i>
                <span>Tabela preço</span>
              </a>
            </th>
          </tr>
          <tr>
            <th class="py-1 px-2"><input [formControl]="form.controls.id" type="number" class="form-control"></th>
            <th class="py-1 px-2"><input [formControl]="form.controls.nome" type="text" class="form-control"></th>
            <th class="py-1 px-2"><input [formControl]="form.controls.descricao" type="text" class="form-control">
            </th>
            <th></th>
          </tr>

        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-index="index" let-rowIndex="rowIndex">
          <tr [pSelectableRow]="rowData">
            <td>{{rowData.id}}</td>
            <td>{{rowData.nome}}</td>
            <td>{{rowData.descricao}}</td>
            <td class="py-1" >
              <div class="d-flex align-items-center justify-content-center">
                <span data-toggle="tooltip" data-placement="bottom" title="Visualizar">
                  <a [routerLink]="['/tabela-preco/laudo','visualizar', rowData.uuid]" class="btn btn-sm btn-icon btn-info mx-1">
                    <i class="mdi mdi-eye"></i>
                  </a>
                </span>
                <span *ngIf="usuario.permissoes.administrador" data-toggle="tooltip" data-placement="bottom" title="Editar">
                  <a [routerLink]="['/tabela-preco','laudo', 'editar', rowData.uuid]" class="btn btn-sm btn-icon btn-primary">
                    <i class="mdi mdi-pencil"></i>
                  </a>
                </span>
                <span *ngIf="usuario.permissoes.administrador" data-toggle="tooltip" data-placement="bottom" title="Excluir">
                  <button (click)="removerTabela(rowData.uuid)" class="btn btn-sm btn-danger btn-icon mx-1">
                    <i class="mdi mdi-delete"></i>
                  </button>
                </span>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer" let-columns>
          <div class="card-footer bg-white row justify-content-between minPage222 ">

            <div class="pb-2 pb-sm-0">
              <ngb-pagination [pageSize]="search.per_page" [boundaryLinks]="true" [collectionSize]="total"
                [(page)]="search.page" (pageChange)="pageChange()" [maxSize]="5" [rotate]="true">
              </ngb-pagination>
            </div>
            <div class="pb-2 pb-sm-0">
              <div class="btn-group" role="group">
                <span data-toggle="tooltip" data-placement="bottom" title="Exportar página em CSV">
                  <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="dt.exportCSV()"
                    class="btn btn-md btn-success" pTooltip="CSV" tooltipPosition="bottom">
                  </button>
                </span>
                <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active': search.per_page==10}"
                  type="button" class="btn btn-outline-primary">10</button>
                <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active': search.per_page==25}"
                  type="button" class="btn btn-outline-primary">25</button>
                <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active': search.per_page==50}"
                  type="button" class="btn btn-outline-primary">50</button>
                <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active':search.per_page==100}"
                  type="button" class="btn btn-outline-primary">100</button>
              </div>
            </div>

          </div>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length + 1">
              Nenhum registro foi encontrado
            </td>
          </tr>
        </ng-template>

      </p-table>

      </div>

    </div>
  </section>
